import { useState, useEffect, useRef } from 'react';

function prefixedKey(key) {
  return `atad-${key}`;
}

export default function useBrowserStorageState(
  type = 'localStorage',
  key,
  defaultValue: any = '',
  { serialize = JSON.stringify, deserialize = JSON.parse } = {}
) {
  const [state, setState] = useState(() => {
    const valueInLocalStorage = window[type].getItem(prefixedKey(key));
    if (valueInLocalStorage) {
      try {
        return deserialize(valueInLocalStorage);
      } catch (err) {
        console.error('Could not deserialize state from storage');
        return { existing: [] };
      }
    }
    return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
  });

  const prevKeyRef = useRef(prefixedKey(key));

  useEffect(() => {
    const prevKey = prevKeyRef.current;
    if (prevKey !== prefixedKey(key)) {
      window[type].removeItem(prevKey);
    }
    prevKeyRef.current = prefixedKey(key);
    window[type].setItem(prefixedKey(key), serialize(state));
  }, [key, state, serialize, type]);

  return [state, setState];
}
